module.exports = __webpack_public_path__ + "img/image13.a22374fd.jpeg";